import { render } from "./ShippingsNotAssigned.vue?vue&type=template&id=26250ece"
import script from "./ShippingsNotAssigned.vue?vue&type=script&lang=js"
export * from "./ShippingsNotAssigned.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__